const actions = {
    componentsData : ({ commit, state }, data) => {
        commit('componentsData', { data })
    },
    setBrData : ({ commit, state }, data) => {
        commit('setBrData', data )
    },
    setBillOpState :({commit},data) => {
        commit('setBillOpState', data)
    },
    setBeforeOpState :({commit},data) => {
        commit('setBeforeOpState', data)
    },
    setBrowseRecord :({commit},data) => {
        commit('setBrowseRecord', data)
    },
    setisOpenRouter :({commit},data) => {
        commit('setisOpenRouter', data)
    },
    setisCloseRouter :({commit},data) => {
        commit('setisCloseRouter', data)
    },
    setRecentList :({commit},data) => {
        commit('setRecentList', data)
    },
    // store.dispatch('setBillOpState')异步提交状态
}
export default actions;